import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = ["aria-controls", "aria-expanded"]
const _hoisted_4 = ["data-url"]
const _hoisted_5 = ["height", "src"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "row justify-content-center align-items-center m-0" }
const _hoisted_10 = { class: "card-body p-md-4 px-0 py-2" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "card-title"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_15 = ["title"]
const _hoisted_16 = { class: "bg-image hover-overlay" }
const _hoisted_17 = ["alt", "src"]
const _hoisted_18 = {
  class: "mask overlay d-flex align-items-center justify-content-center text-light card-img",
  style: {"background-color":"rgba(0, 0, 0, 0.6)"}
}
const _hoisted_19 = ["alt", "src"]

import {
        MDBCol,
        MDBIcon,
    } from "mdb-vue-ui-kit";
    import { ref, toRefs, Ref, onMounted } from "vue";
    import "linkifyjs/lib/linkify-string";
    import 'linkify-plugin-mention';
    import 'linkify-plugin-hashtag';
    import * as timeago from 'timeago.js';
    import { decodeHtml } from "@/functions/utility";

    import { Static } from 'runtypes';
    import { Article } from '@/types/runtypes/article';

    // define props
    interface Props {
        article: Static<typeof Article>
        smallImage?: boolean
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
    article: null,
    smallImage: { type: Boolean }
  },
  setup(__props: any) {

const { article, smallImage = false } = __props as {
        article: Static<typeof Article>
        smallImage?: boolean
    }

    

    const taglineCollapse = ref(false);
    const imgExpand = ref(false);
    const el = ref(null);

    const articleTimestamp = article.info.publicSquare.package.publishDate;
    const articleTime = ref(getReadableDate(articleTimestamp));

    onMounted(() => {
        makeIntersectionObserver();
    });

    /**
    * Update Timestamps to keep timestamps in viewport up to date
    * @param element Object to observe and update timestamps on
    */
    function updateTimestamps(element: any) {
        // get all elements with class
        const elements = element.querySelectorAll('.dynamicTimestamp');
        const limit = 24 * 60 * 60 * 1000; // 24 hours
        const current = Date.now(); // current time

        // iterate over elements
        for (let i = 0; i < elements.length; i++) {
            let timestamp = elements[i]?.title ?? null;

            // if title property is null or undefined, continue
            if (timestamp === null) {
                continue;
            }

            // ensure that timestamp is able to be parsed by Date constructor
            timestamp = timestamp.replace(' at ', ' ');

            // create epoch timestamp
            let epoch = new Date(timestamp).getTime();

            const difference = current - epoch;

            if (difference < limit) {
                // if difference is less than 24 hours, use timeago.js
                elements[i].innerHTML = timeago.format(timestamp);
                continue;
            }

            // if difference is greater than 24 hours, use readable date
            elements[i].innerHTML = getReadableDate(timestamp);
        }
    }

    /**
    * Get a Readable Date from the Timestamp
    *
    * @param timestamp
    * @return Date
    */
    function getReadableDate(timestamp: number) {
        const options = {
            hour: 'numeric',
            minute: 'numeric',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }

        return new Date(timestamp).toLocaleString('en-US', options);
    }

    /**
    * Create Intersection Observer associated with each individual Feed Article and Beacon
    */
    function makeIntersectionObserver() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry && entry.isIntersecting) {
                    if (entry.target.classList.contains('beacon-sent') === false) {
                        entry.target.classList.add('beacon-sent');

                        let params = new URLSearchParams({
                            utm_source: 'ology',
                            utm_medium: 'feed',
                            utm_campaign: 'ology.com',
                        });

                        let url = process.env.VUE_APP_BEACON_ENDPOINT + '/' + article.infoHash + '?' + params.toString();

                        navigator.sendBeacon(url);
                    }

                    // when element is in viewport, update timestamps
                    updateTimestamps(entry.target);

                    const interval = setInterval(() => {
                        updateTimestamps(entry.target);
                    }, 10 * 1000);

                    entry.target.dataset.interval = interval;
                } else if (entry && entry.isIntersecting === false && typeof entry.target.dataset.interval === 'string') {
                    clearInterval(entry.target.dataset.interval);
                    entry.target.dataset.interval = null;
                }
            });
        });

        observer.observe(el.value);
    }

    function replaceByDefault(e: any) {
        e.target.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    id: 'article-' + __props.article.infoHash,
    ref: (_value, _refs) => {
      _refs['el'] = _value
      el.value = _value
    }
  }, [
    _createElementVNode("div", {
      class: _normalizeClass('card-header ' + (taglineCollapse.value ? '' : 'p-0'))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex align-items-center justify-content-between header-click", taglineCollapse.value ? '' : 'p-3']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (taglineCollapse.value = !taglineCollapse.value)),
          "aria-controls": 'tagline-' + __props.article.infoHash,
          "aria-expanded": taglineCollapse.value
        }, [
          _createVNode(_component_router_link, {
            to: `${_ctx.$router.resolve({name: 'Publisher'}).href}/${__props.article.createdBy}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "d-flex align-items-center",
                "data-url": __props.article.createdBy
              }, [
                (__props.article.provenance.publisher.image != '')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "rounded-circle mx-1",
                      height: taglineCollapse.value ? 75 : 35,
                      src: __props.article.provenance.publisher.image,
                      onError: replaceByDefault,
                      alt: "",
                      loading: "lazy"
                    }, null, 40, _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  class: _normalizeClass(["text-muted m-0 mx-1", taglineCollapse.value ? 'h3 mx-3' : ''])
                }, _toDisplayString(__props.article.provenance.publisher.name), 3),
                (taglineCollapse.value)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: __props.article.provenance.publisher.url,
                      target: "_blank",
                      color: "primary"
                    }, [
                      (/twitter.com/.test(__props.article.provenance.publisher.url) === true)
                        ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                            key: 0,
                            icon: "twitter",
                            iconStyle: "fab",
                            size: "md"
                          }))
                        : _createCommentVNode("", true),
                      (/twitter.com/.test(__props.article.provenance.publisher.url) === false)
                        ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                            key: 1,
                            icon: "link",
                            iconStyle: "fas",
                            size: "md",
                            class: "text-body"
                          }))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["to"]),
          (taglineCollapse.value)
            ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                key: 0,
                icon: "times",
                iconStyle: "fas",
                size: "lg",
                class: "mx-1"
              }))
            : (_openBlock(), _createBlock(_unref(MDBIcon), {
                key: 1,
                icon: "plus",
                iconStyle: "fas",
                size: "sm",
                class: "mx-1"
              }))
        ], 10, _hoisted_3),
        _createElementVNode("div", {
          id: 'tagline-' + __props.article.infoHash,
          class: _normalizeClass('collapse ' + (taglineCollapse.value ? 'show' : ''))
        }, [
          _createVNode(_component_router_link, {
            to: `${_ctx.$router.resolve({name: 'Publisher'}).href}/${__props.article.createdBy}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                class: "mt-3 text-muted",
                innerHTML: _unref(decodeHtml)(__props.article.provenance.publisher.tagline || '')
              }, null, 8, _hoisted_8)
            ]),
            _: 1
          }, 8, ["to"])
        ], 10, _hoisted_7)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(MDBCol), {
        col: "12",
        lg: __props.article.info.publicSquare.package.image != '' && imgExpand.value == false ? '8' : '12'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              href: __props.article.info.publicSquare.package.canonicalUrl,
              target: "_blank",
              class: "text-muted pointer"
            }, [
              (__props.article.info.publicSquare.package.title != '')
                ? (_openBlock(), _createElementBlock("h5", _hoisted_12, _toDisplayString(__props.article.info.publicSquare.package.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "card-text",
                innerHTML: _unref(decodeHtml)(__props.article.info.publicSquare.package.description)
              }, null, 8, _hoisted_13),
              _createElementVNode("div", _hoisted_14, [
                (/twitter.com/.test(__props.article.provenance.publisher.url) === true)
                  ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                      key: 0,
                      icon: "twitter",
                      iconStyle: "fab",
                      size: "md"
                    }))
                  : _createCommentVNode("", true),
                (/twitter.com/.test(__props.article.provenance.publisher.url) === false)
                  ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                      key: 1,
                      icon: "link",
                      iconStyle: "fas",
                      size: "md",
                      class: "text-body"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  class: "text-muted m-0 mx-1 dynamicTimestamp articleTimestamp",
                  title: getReadableDate(_unref(articleTimestamp))
                }, _toDisplayString(articleTime.value), 9, _hoisted_15)
              ])
            ], 8, _hoisted_11)
          ])
        ]),
        _: 1
      }, 8, ["lg"]),
      (__props.article.info.publicSquare.package.image != '' && __props.smallImage === false)
        ? (_openBlock(), _createBlock(_unref(MDBCol), {
            key: 0,
            col: "12",
            lg: "4",
            class: _normalizeClass(["p-2", imgExpand.value ? 'col-lg-12' : ''])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("img", {
                  class: _normalizeClass(imgExpand.value ? 'card-img' : 'card-img limit-height'),
                  alt: __props.article.provenance.publisher.name,
                  src: __props.article.info.publicSquare.package.image,
                  loading: "lazy"
                }, null, 10, _hoisted_17),
                _createElementVNode("button", {
                  class: "d-none d-lg-block d-xl-block border-0",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (imgExpand.value = !imgExpand.value))
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    (imgExpand.value)
                      ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                          key: 0,
                          icon: "compress",
                          iconStyle: "fas",
                          size: "3x"
                        }))
                      : (_openBlock(), _createBlock(_unref(MDBIcon), {
                          key: 1,
                          icon: "expand",
                          iconStyle: "fas",
                          size: "lg"
                        }))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (__props.article.info.publicSquare.package.image != '' && __props.smallImage)
        ? (_openBlock(), _createBlock(_unref(MDBCol), {
            key: 1,
            col: "4",
            class: "p-2 d-none d-lg-block"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "card-img hard-limit-height",
                alt: __props.article.provenance.publisher.name,
                src: __props.article.info.publicSquare.package.image,
                loading: "lazy"
              }, null, 8, _hoisted_19)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}
}

})